import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop, PropType } from '@typegoose/typegoose'
import { BaseEntity } from '../base/BaseEntity'
import { RelatedEntity } from '../base/RelatedEntity'
import { generateEntityId } from '../generateEntityId'

/**
 * A node in the per-tenant tree of blog categories. `parent` is null at the top level; `ancestors` holds the ids from the
 * top level down to the parent, so a subtree is one `{ ancestors: id }` query.
 */
@ObjectType()
@InputType('BlogCategoryInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class BlogCategory extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('cat') })
  declare _id: string

  @Field(() => RelatedEntity, { nullable: true })
  @Prop({ type: RelatedEntity })
  parent?: RelatedEntity | null

  @Field(() => [String], { nullable: true })
  @Prop({ type: [String] }, PropType.ARRAY)
  ancestors?: string[]
}
